module.exports = __webpack_public_path__ + "img/Aura_sparkle.d33ee5fe.png";